//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props:['supporlist','sjmon'],
  data () {
    return {
      imgUrl:require('../assets/images/fpw_logo_small.png')
    }
  },
  methods: {
    base64(name) {
      return Base64.decode(name.substring(11))
    },
    getNickName(nickName) {
      if(nickName) {
        return nickName.includes("WX_NICKNAME")?this.nicknamesolice(this.base64(nickName)):this.nicknamesolice(nickName)
      }else{
        return '爱心人士' 
      }
    },
    nicknamesolice (a) {
      if(a.length>9){
        a = a.slice(0,9)+'...'
      }
      return a
    },
    getHeadth (head) {
      return (head.includes("http://")||head.includes("https://"))?head:this.zc_userhead+head
    },
    goQKL (data,isclick) {
      if(this.isWeixinCient()){
        if(isclick==2){
          window.location.href=this.QKL_URL+data
        }
      }else{
        if(isclick==2){
          window.location.href=this.QKL_URL+data+'&platform=app'
        }
      }
    },
    emitTop () {
      this.$emit('childbyvalue',1)
    },
    emitTop1 (n) {
      this.$emit('childbyvalue', 2)
    },
    timenew(loveTime){
      let loTime = this.getDateTimeStamp(loveTime);
      let minute = 1000 * 60;
        let hour = minute * 60;
        let day = hour * 24;
        let halfamonth = day * 15;
        let month = day * 30;
        let now = new Date().getTime();
        let diffValue = now - loTime;
        if(diffValue < 0){return;}
        let monthC =diffValue/month;
        let weekC =diffValue/(7*day);
        let dayC =diffValue/day;
        let hourC =diffValue/hour;
        let minC =diffValue/minute;
        let time = new Date(loTime);
        if(dayC>1&&monthC<=1){
            loTime=""+ parseInt(dayC) +"天前";
        }
        else if(hourC>=1&&dayC<1){
            loTime=""+ parseInt(hourC) +"小时前";
        }
        else if(minC>=1&&hourC<1){
            loTime=""+ parseInt(minC) +"分钟前";
        }else if(minC<1){
            loTime="刚刚";
        }else{
            loTime= this.formatDate(time)
        }
        return loTime
    },
    getDateTimeStamp (dateStr) {
        return Date.parse(dateStr.replace(/-/gi,"/"));
    },
    formatDate(now) {
        var year=now.getFullYear();
        var month=now.getMonth()+1;
        var date=now.getDate();
        var hour=now.getHours();
        var minute=now.getMinutes();
        var second=now.getSeconds();
        return year+"-"+month+"-"+date;
    } 
  },
  mounted () {
    
  },
  watch:{

  }
}



// WEBPACK FOOTER //
// ./src/crowd_fund/zcHelprecord.vue